// Adjust the enum imports to your project
// import { PieceFilterDTOOrderOptionEnum, PieceFilterDTOInstrumentationTypeEnum, PieceFilterDTOComposerCountriesEnum } from "...";

import { PieceFilterDTO } from "../openapi-generated-client";

function first(sp: URLSearchParams, key: string): string | undefined {
  const v = sp.get(key);
  return v === null ? undefined : v;
}

function parseNumber(v?: string): number | undefined {
  if (v === undefined) return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
}

function parseBoolean(v?: string): boolean | undefined {
  if (v === undefined) return undefined;
  if (v === "true" || v === "1") return true;
  if (v === "false" || v === "0") return false;
  return undefined;
}

function parseStringArray(sp: URLSearchParams, key: string): string[] | undefined {
  // supports ?keywords=a&keywords=b and ?keywords=a,b
  const all = sp.getAll(key).flatMap((entry) =>
    entry.split(",").map((s) => s.trim()).filter(Boolean),
  );
  return all.length ? all : undefined;
}

// For numeric arrays like difficulties=1,2
function parseNumberArray(sp: URLSearchParams, key: string): number[] | undefined {
  const strings = parseStringArray(sp, key);
  if (!strings) return undefined;
  const nums = strings.map((s) => Number(s)).filter((n) => Number.isFinite(n));
  return nums.length ? nums : undefined;
}

export function parsePieceFilterFromSearchParams(
  sp: URLSearchParams,
  defaults: PieceFilterDTO,
): PieceFilterDTO {
  // IMPORTANT: validate enums against allowed values if you want strictness.
  // Below assumes strings match your enum values.

  const keywords = parseStringArray(sp, "keywords");
  const difficulties = parseNumberArray(sp, "difficulties");
  const composerCountries = parseStringArray(sp, "composerCountries") as
    | PieceFilterDTO["composerCountries"]
    | undefined;

  const next: PieceFilterDTO = {
    ...defaults,

    search: first(sp, "search") ?? defaults.search,

    orderOption: (first(sp, "orderOption") as PieceFilterDTO["orderOption"]) ?? defaults.orderOption,

    currentPage: parseNumber(first(sp, "currentPage")) ?? defaults.currentPage,

    keywords: keywords ?? defaults.keywords,

    totalInstrumentAmount:
      parseNumber(first(sp, "totalInstrumentAmount")) ?? defaults.totalInstrumentAmount,

    original: parseBoolean(first(sp, "original")) ?? defaults.original,

    durationFrom: parseNumber(first(sp, "durationFrom")) ?? defaults.durationFrom,
    durationTo: parseNumber(first(sp, "durationTo")) ?? defaults.durationTo,

    yearFrom: parseNumber(first(sp, "yearFrom")) ?? defaults.yearFrom,
    yearTo: parseNumber(first(sp, "yearTo")) ?? defaults.yearTo,

    maxPrice: parseNumber(first(sp, "maxPrice")) ?? defaults.maxPrice,

    difficulties: difficulties ?? defaults.difficulties,

    instrumentationType:
      (first(sp, "instrumentationType") as PieceFilterDTO["instrumentationType"]) ??
      defaults.instrumentationType,

    composerCountries: composerCountries ?? defaults.composerCountries,
  };

  console.log(next);

  return next;
}